import { SELECT_MULTICAST_GROUP } from './typeConstants';

export const selectMulticastGroup = (data) => ({
    type: SELECT_MULTICAST_GROUP,
    data,
});